document.addEventListener("DOMContentLoaded", function () {
    const charts = document.querySelectorAll(".sizes-chart");

    charts.forEach(chart => {
        const tabs = chart.querySelectorAll("a[href^='#']");
        const tabItems = chart.querySelectorAll(".js-sizes-tabs li a");
        const tabContents = chart.querySelectorAll(".sizes-chart__tab");
        const lava = chart.querySelector(".js-sizes-tabs .active-bg");

        function moveLava(target) {
            const rect = target.getBoundingClientRect();
            const parentRect = target.closest(".js-sizes-tabs").getBoundingClientRect();
            lava.style.width = `${rect.width}px`;
            lava.style.left = `${rect.left - parentRect.left}px`;
        }

        function activateTab(target) {
            tabContents.forEach(content => content.classList.remove("active"));
            tabItems.forEach(item => item.classList.remove("active"));

            const targetTab = chart.querySelector(`.sizes-chart__tab[data-tab='${target}']`);
            const activeLinks = chart.querySelectorAll(`a[href='#${target}']`);

            if (targetTab) {
                targetTab.classList.add("active");
                activeLinks.forEach(link => {
                    link.classList.add("active");
                    moveLava(link);
                });
            }
        }

        tabs.forEach(tab => {
            tab.addEventListener("click", function (e) {
                e.preventDefault();
                const target = this.getAttribute("href").replace("#", "");
                activateTab(target);
            });
        });
      
        const initialActive = chart.querySelector(".js-sizes-tabs a.active");
        if (initialActive && lava) {
            moveLava(initialActive);
        }

        window.addEventListener("resize", () => {
            const activeTab = chart.querySelector(".js-sizes-tabs a.active");
            if (activeTab && lava) {
                moveLava(activeTab);
            }
        });

        const guideToggle = document.querySelector(".product__size-guide summary");
        if (guideToggle) {
            guideToggle.addEventListener("click", () => {
                setTimeout(() => {
                    const activeTab = chart.querySelector(".js-sizes-tabs a.active");
                    if (activeTab && lava) {
                        moveLava(activeTab);
                    }
                }, 100);
            });
        }
    });

    const sizeChartInput = document.querySelector("#size_chart");
    const triggers = document.querySelectorAll(".product__size-guide summary, .product__accordion summary");

    triggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
            if (sizeChartInput) {
                sizeChartInput.value = "true";
            }
        });
    });
});
